import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { ViewColumn } from '../../../view-column';
import { AppletAuditTrailListingComponent } from '../developer-tools/applet-audit-trail/applet-audit-trail-listing/applet-audit-trail-listing.component';
import { AppletAuditTrailEditComponent } from '../developer-tools/applet-audit-trail/applet-audit-trail/applet-audit-trail-edit.component';

@Injectable()

// This is where we need to change the view columns.
export class AppletAuditTrailPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, AppletAuditTrailListingComponent, 'Applet Audit Trail Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, AppletAuditTrailListingComponent, 'Applet Audit Trail Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(1, AppletAuditTrailEditComponent, 'Applet Audit Trail View', {
        deactivateReturn: false,
        selectedIndex: 0,
        deactivateAdd: false,
        deactivateList: false
      }),
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
